<kendo-multiviewcalendar
		kendoDateRangeSelection
		[views]="1"
		[disabled]="disabled"
		[(focusedDate)]="focusedDate"
		[(activeView)]="activeView"
		[(activeRangeEnd)]="activeRangeEnd"
		[selectionRange]="selectionRange"
		(selectionRangeChange)="handleSelectionRangeChange($event)">
	<kendo-calendar-messages
		[parentViewButtonTitle]="'CalendarParentViewNavigation' | cpActionTranslate">
	</kendo-calendar-messages>
</kendo-multiviewcalendar>
